export default {
    validate(value) {
        let regex = new RegExp(/[A-z][ ][A-z]/);
        let result = regex.exec(value);
      
        return !!result;
    }
};